




















import { Component, Mixins, Prop, Watch, Emit } from 'vue-property-decorator';
import { hasElements } from '../utils';
import Axios from 'axios';
import { NotificationStoreHelper, RootStoreHelper } from '../mixins';
import { Destroyed, Mounted } from '../decorators';

@Component({
    components: {}
})
export default class Carrousel extends Mixins(NotificationStoreHelper, RootStoreHelper) {
    @Prop({ default: [] }) images: Array<object>;
    @Prop({ default: 'src' }) imageSrc: string;
    @Prop({ default: 'auto' }) height: string;
    @Prop({ default: '' }) customClass: string;
    @Prop({ default: '' }) carouselItemClass: string;
    currentIndex: number = 0;

    @Emit()
    changeItem(actualIndex: number) {
        return actualIndex;
    }

    @Emit()
    leftArrowClick() {}

    @Emit()
    rightArrowClick() {}

    updateCurrentIndex(position: number) {
        this.currentIndex = position;
        this.changeItem(position);
    }
}
